import {useCallback, type ComponentProps, type ChangeEventHandler, useState} from 'react';
import {PepIcon} from './PepIcon';
import classNames from 'classnames';

type Props = ComponentProps<'div'> & {
  placeholder?: string;
  text: string;
  onTextChange: (text: string) => void | Promise<void>;
  id: string;
  unMountInput?: boolean;
};

const TextSearchBox = ({className, placeholder, text, onTextChange, id, unMountInput = false, ...props}: Props) => {
  const [focused, setFocused] = useState(false);
  const onFocus = useCallback(() => setFocused(true), []);
  const onBlur = useCallback(() => setFocused(false), []);
  const handleSearchTextChange = useCallback<ChangeEventHandler<HTMLInputElement>>(
    e => onTextChange(e.target.value),
    [onTextChange]
  );
  return (
    <div className={classNames('relative flex items-center', className)} {...props}>
      <div className="pointer-events-none absolute inset-y-0 start-4 flex items-center">
        <PepIcon iconName="Search" />
      </div>
      {((text.length === 0 && !focused) || unMountInput) && (
        <div className="pointer-events-none absolute start-10 select-none text-foreground/75">{placeholder}</div>
      )}
      {!unMountInput && (
        <input
          className="flex w-full flex-row rounded-full border border-midground3 bg-background py-2 pe-4 ps-10 text-foreground outline-primary focus:border-primary focus:outline-none"
          type="text"
          value={text}
          id={id}
          onChange={handleSearchTextChange}
          onFocus={onFocus}
          onBlur={onBlur}
          aria-label={placeholder}
          autoComplete={'off'}
        />
      )}
    </div>
  );
};

export default TextSearchBox;
